define('businessServices/signup/signupWebAppSignIn',[
    'businessServices/authentication/authenticationManager',
    'businessServices/authentication/stores/signupAuthenticationStore',
    'businessServices/router/router',
    'businessServices/signup/affiliateSignup',
    'businessServices/signup/signupCookieStore',
    'businessServices/signup/signupResumeDestinationStore',
    'businessServices/signup/signupSessionStore',
    'constants/signupSessionStatusConstants',
    'persistence/repositories/liveReceptionistOnboardingRepository',
    'settings/navigationConfiguration'
], function() {
    const _authenticationManager = require('businessServices/authentication/authenticationManager');
    const _navigationConfiguration = require('settings/navigationConfiguration');
    const _router = require('businessServices/router/router');
    const _signupSessionStatusConstants = require('constants/signupSessionStatusConstants');

    let _affiliateSignup = null;
    let _liveReceptionistOnboardingRepository = null;
    let _signupAuthenticationStore = null;
    let _signupCookieStore = null;
    let _signupResumeDestinationStore = null;
    let _signupSessionStore = null;

    const _navigateToLoginScreen = () => {
        _router.navigate(_navigationConfiguration.loginPageUrl);
    };

    const _clearWelcomeInfoCaptureThen = (continueToDestination) => {
        _liveReceptionistOnboardingRepository.updateWelcomeInfoCapture()
            .fail(continueToDestination)
            .done(continueToDestination);
    };

    const _signInToWebApp = (destinationUrl, shouldClearWelcomeInfoCapture = false) => {
        _signupAuthenticationStore.init();
        _signupAuthenticationStore.load()
            .done((signupSessionId) => {
                if (!signupSessionId) {
                    _navigateToLoginScreen();
                    return;
                }

                _signupSessionStore.init();
                _signupSessionStore.getState(true)
                    .fail(() => _navigateToLoginScreen())
                    .done((signupSessionState) => {
                        const signupStatus = signupSessionState.signupDocument.signupSessionStatus;
                        if (signupStatus !== _signupSessionStatusConstants.accountCreationCompleted) {
                            // The account is still being created, so the login screen finishes the
                            // sign-in instead. Hand it the destination the customer already chose.
                            _signupResumeDestinationStore.save(destinationUrl);
                            _navigateToLoginScreen();
                            return;
                        }

                        const signupEmailAddress = signupSessionState.signupDocument.emailAddress;
                        const signupPassword = signupSessionState.password;
                        if (!signupPassword) {
                            _navigateToLoginScreen();
                            return;
                        }

                        _authenticationManager.loginWithCredentials(signupEmailAddress, signupPassword)
                            .fail(() => _navigateToLoginScreen())
                            .done((loginResult) => {
                                _signupSessionStore.clear();
                                _signupAuthenticationStore.clear();
                                _affiliateSignup.clear();
                                _signupCookieStore.clear();
                                if (loginResult.success === false) {
                                    _navigateToLoginScreen();
                                    return;
                                }

                                const continueToDestination = () => _router.navigate(destinationUrl);
                                if (shouldClearWelcomeInfoCapture) {
                                    _clearWelcomeInfoCaptureThen(continueToDestination);
                                    return;
                                }

                                continueToDestination();
                            });
                    });
            });
    };

    const _init = () => {
        const AffiliateSignupConstructor = require('businessServices/signup/affiliateSignup');
        _affiliateSignup = new AffiliateSignupConstructor();

        const SignupCookieStoreConstructor = require('businessServices/signup/signupCookieStore');
        _signupCookieStore = new SignupCookieStoreConstructor();

        const SignupAuthenticationStoreConstructor = require('businessServices/authentication/stores/signupAuthenticationStore');
        _signupAuthenticationStore = new SignupAuthenticationStoreConstructor();

        const SignupResumeDestinationStoreConstructor = require('businessServices/signup/signupResumeDestinationStore');
        _signupResumeDestinationStore = new SignupResumeDestinationStoreConstructor();

        const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
        _signupSessionStore = new SignupSessionStoreConstructor();

        const LiveReceptionistOnboardingRepositoryConstructor = require('persistence/repositories/liveReceptionistOnboardingRepository');
        _liveReceptionistOnboardingRepository = new LiveReceptionistOnboardingRepositoryConstructor();
    };

    return function() {
        const self = this;
        self.init = _init;
        self.signInToWebApp = _signInToWebApp;
    };
});

